import { Navigate, Outlet } from 'react-router-dom';
import { usePWAMode } from '../../hooks/usePWAMode';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

/**
 * Route guard for PWA offline mode.
 * When running as an installed PWA without internet, redirects to home.
 * When online (even in PWA mode), all routes are accessible.
 */
export default function PWARoute() {
  const isPWA = usePWAMode();
  const { isOffline } = useOnlineStatus();

  if (isPWA && isOffline) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
